// extracted by mini-css-extract-plugin
module.exports = {"twoColumnsParagraphs":"styles_twoColumnsParagraphs__YkJ4s","thesis":"styles_thesis__yhDV7","description":"styles_description__O_gNi"};